var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#zip_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.134 35.793H6.01v3.918h5.861v6.054c-.052 3.941-1.872 5.702-5.877 5.702-4.007 0-5.825-1.76-5.877-5.702v-6.054h.016zm6.95 11.425a1.96 1.96 0 1 1-2.246-3.211 1.96 1.96 0 0 1 2.245 3.211",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.995 31.884h5.877v3.919H5.995zM.117 27.966h5.878v3.918H.117zm5.878-3.919h5.877v3.919H5.995zM.117 20.13h5.878v3.918H.117zm5.878-3.918h5.877v3.918H5.995zM.117 12.292h5.878v3.919H.117zm5.878-3.918h5.877v3.918H5.995zM.117 4.455h5.878v3.919H.117zM5.995.537h5.877v3.918H5.995z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.872.537H5.995v.98h5.877zM5.995 5.435v-.98H.117v.98zm0 6.857H.117v.98h5.878zm5.877-2.939v-.98H5.995v.98zm-5.877 6.858v.98h5.877v-.98zm0 3.918H.117v.98h5.878zm0 3.918v.98h5.877v-.98zm0 3.919H.117v.98h5.878zm0 3.918v.98h5.877v-.98zm0 3.903H.134v.98h5.86zM.134 39.705H.117v.98h.017zm11.738.98v-.98h-5.86v.98zm-5.877 6.857a1.96 1.96 0 0 0 1.897-1.47l.025.108a1.96 1.96 0 1 1-3.82-.107 1.96 1.96 0 0 0 1.898 1.469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.117.537h11.755V51.46H.117z"
  })))));
};
export default SvgZip;